import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Edit from "../users/edit";
import { fetchUserForm } from "../../../modules/api";
import { updatePageTitle } from "../../../modules/legacyUtils";
export default function UserFormPage({ authenticityToken }) {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const returnPath = location.state?.prevPathname || `/users/${id}`;
    const [formData, setFormData] = useState(null);
    useEffect(() => { updatePageTitle('Basic details'); }, []);
    useEffect(() => { let cancelled = false; fetchUserForm(id).then(data => { if (cancelled)
        return; setFormData(data); }); return () => { cancelled = true; }; }, [id]);
    if (!formData)
        return null;
    return /*#__PURE__*/ React.createElement(Edit, { authenticityToken: authenticityToken, resource: formData.resource, trades: formData.trades, modEmployee: formData.modEmployee, onCancel: () => navigate(returnPath) // Hard redirect (not navigate()) - #update may set a real Rails session
        // flash (e.g. "We have sent a confirmation email...") which, like every
        // other Phase 1/2 flash-setting action, only ever displays via a real
        // page render.
        ,
        onAfterSubmit: () => navigate(returnPath) });
}
